import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function NaucnoistrazivackiRad() {
  const [t] = useTranslation();
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Naučnoistraživački rad" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">{t("rad.title")}</h2>
              <p className="textjustify">{t("rad.p1")}</p>
              <h3 className="mb-20">{t("rad.tabelanaslov")}</h3>
              <table className="table ofpep-section">
                <thead>
                  <tr>
                    <th>{t("rad.rb")}</th>
                    <th>{t("rad.nazivProjekta")}</th>
                    <th>{t("rad.norm")}</th>
                    <th>{t("rad.izvorfin")}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1.</td>
                    <td>
                      Introducing ISO 9001:2015 + IWA 2 recommendations for
                      higher education
                    </td>
                    <td>N</td>
                    <td>EBRD (sufinansiranje)</td>
                  </tr>
                  <tr>
                    <td>2.</td>
                    <td>Preparation of the Curriculum of Open Innovation</td>
                    <td>M</td>
                    <td>
                      Erasmus+ call for proposals - Capacity Building in the
                      field of Youth 2020
                    </td>
                  </tr>
                  <tr>
                    <td>3.</td>
                    <td>
                      Koorganizacija naučne konferencije EECME - Eastern
                      European Conference of Management and Economics
                    </td>
                    <td>M</td>
                    <td>Samostalno</td>
                  </tr>
                  <tr>
                    <td>4.</td>
                    <td>
                      Koorganizacija naučne konferencije COAST - International
                      Conference on Advances in Science And Technology
                    </td>
                    <td>M</td>
                    <td>Samostalno</td>
                  </tr>
                  <tr>
                    <td>5.</td>
                    <td>International Summer School Bar “Beyond Horizon”</td>
                    <td>M</td>
                    <td>Samostalno</td>
                  </tr>
                  <tr>
                    <td>6.</td>
                    <td>Kratkoročna naučna mobilnost istraživača</td>
                    <td>M</td>
                    <td>Ministarstvo prosvjete nauke i inovacija Crne Gore</td>
                  </tr>
                  <tr>
                    <td>7.</td>
                    <td>MED NETWORK</td>
                    <td>M</td>
                    <td>EU S3 pametna specijalizacija</td>
                  </tr>
                  <tr>
                    <td>8.</td>
                    <td>
                      mYouth Marketing Leaders for Sustainable Development
                    </td>
                    <td>M</td>
                    <td>EU</td>
                  </tr>
                </tbody>
              </table>

              <div className="values-section">
                <h3 className="pb-10">{t("rad.oprema")}</h3>
                <ul>
                  <li>
                    Laptop računar Acer 15.6 Intel Core I3 10th gen 8GB DDR4 256
                    GB ssd
                  </li>
                  <li>
                    Laptop računar Acer 15.6 Intel Core I3 10th gen 8GB DDR4 256
                    GB ssd
                  </li>
                  <li>
                    Laptop računar Acer 15.6 Intel Core I3 10th gen 8GB DDR4 256
                    GB ssd
                  </li>
                  <li>
                    Laptop računar Acer 15.6 Intel Core I3 10th gen 8GB DDR4 256
                    GB ssd
                  </li>
                  <li>
                    Laptop računar Dell 156 Intel Core I3 9th gen 8 gb ddr4 512
                    gb ssd
                  </li>
                  <li>
                    Laptop Toshiba 15.6 Intel Celeron 24ghz 4gb ddr3 512 gb hdd
                  </li>
                  <li>
                    Desktop računar Cooler Master Intel Core I5 11400 16gb ddr4
                    3200 mhz 480 gb PCLe nvme m2 ssd
                  </li>
                  <li>
                    Desktop računar Intel Core I7 11600 16gb ddr4 3200 mhz 480
                    gb pclE nvme m2 ssd
                  </li>
                  <li>Desktop računar Intel Pentium 4gb ddr3 512 gb hdd</li>
                  <li>Desktop računar Core I5 8 gb ddr4 512 gb ssd</li>
                  <li>Desktop računar Intel Pentium 4gb ddr3 512 gb hdd</li>
                  <li>Desktop računar Intel Celeron 4gb ddr3 512 gb hdd</li>
                  <li>Desktop računar AMD Athlon 4gb ddr3 512 gb hdd</li>
                  <li>EPSON V11HA86040 PROJEKTOR</li>
                  <li>ViewSonic PJD5533W WXGA 3D DLP projektor</li>
                  <li>EPSON V11HA85040 PROJEKTOR</li>
                  <li>HP 4ZB82A MFP LASERSKI STAMPAC</li>
                  <li>HP 4JB82A MFP LASERSKI STAMPAC</li>
                  <li>SAMSUNG SL-M2070/SEE MFP LASERSKI STAMPAC</li>
                  <li>HP 4JB82A MFE LASERSKI STAMPAC</li>
                </ul>
              </div>

              <div className="ofpep-section textjustify">
                <h3 className="pb-10">{t("rad.baze")}</h3>
                <ul>
                  <li>
                    <a
                      href="https://pubmed.ncbi.nlm.nih.gov/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      PubMed <i className="fas fa-external-link-alt"></i>
                    </a>{" "}
                    - Iako se fokusira na medicinska istraživanja PubMed pruža
                    pristup mnogim člancima i istraživanjima iz područja
                    ekonomije zdravstva i medicinske pravde.
                  </li>
                  <li>
                    <a
                      href="https://www.ssrn.com/index.cfm/en/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      SSRN (Social Science Research Network){" "}
                      <i className="fas fa-external-link-alt"></i>
                    </a>{" "}
                    - Ova baza nudi pristup preprintovima i radovima iz
                    društvenih nauka uključujući ekonomiju pravo i druge srodne
                    discipline.
                  </li>
                  <li>
                    <a
                      href="https://doaj.org/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Directory of Open Access Journals (DOAJ){" "}
                      <i className="fas fa-external-link-alt"></i>
                    </a>{" "}
                    - Ovo je direktorijum koji sadrži veliki broj časopisa
                    otvorenog pristupa iz različitih naučnih oblasti uključujući
                    ekonomiju i pravo.
                  </li>
                  <li>
                    <a
                      href="https://arxiv.org/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      arXiv <i className="fas fa-external-link-alt"></i>
                    </a>{" "}
                    - Iako je arXiv poznat po fokusiranju na fiziku matematiku i
                    računarstvo takođe sadrži radove iz oblasti ekonomije
                    kvantitativne finansije i drugih srodnih polja.
                  </li>
                  <li>
                    <a
                      href="https://scholar.google.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Google Scholar{" "}
                      <i className="fas fa-external-link-alt"></i>
                    </a>{" "}
                    - Dok Google Scholar nije baza podataka u tradicionalnom
                    smislu omogućava pristup mnogim naučnim člancima tezama
                    knjigama i drugim radovima koji su dostupni besplatno ili
                    otvorenog pristupa.
                  </li>
                  <li>
                    <a
                      href="https://hudoc.echr.coe.int/#{%22documentcollectionid2%22:[%22GRANDCHAMBER%22%22CHAMBER%22]}"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Evropski sud za ljudska prava u Strazburu{" "}
                      <i className="fas fa-external-link-alt"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://eur-lex.europa.eu/homepage.html"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Zakonodavstvo EU{" "}
                      <i className="fas fa-external-link-alt"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://curia.europa.eu/jcms/jcms/j_6/en/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Sud pravde EU <i className="fas fa-external-link-alt"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.paragraf.me/besplatni_propisi_cg.html"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Paragraf.me - Elektronska pravna baza propisa Crne Gore{" "}
                      <i className="fas fa-external-link-alt"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.asistent.me/zakoni.html"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Online vodič kroz propise u Crnoj Gori{" "}
                      <i className="fas fa-external-link-alt"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://me.propisi.net/category/izbor-propisa/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Besplatni propisi Crne Gore{" "}
                      <i className="fas fa-external-link-alt"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://pravoiprivreda.rs/arhiva-idx/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Pravo i privreda - pravni časopis{" "}
                      <i className="fas fa-external-link-alt"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://kopaonikschool.org/publikacije/pravni-zivot/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Kopaonička škola prirodnog prava - pravni časopis{" "}
                      <i className="fas fa-external-link-alt"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.stranipravnizivot.rs/index.php/SPZ/issue/archive"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Strani pravni život - međunarodni pravni časopis{" "}
                      <i className="fas fa-external-link-alt"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://projuris.org/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Projuris - pravna baza podataka{" "}
                      <i className="fas fa-external-link-alt"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.insol-europe.org/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      INSOL Europe - Asocijacija za stečajno pravo i pravo
                      restrukturiranja{" "}
                      <i className="fas fa-external-link-alt"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://onlinelibrary.wiley.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Wiley Online Biblioteka{" "}
                      <i className="fas fa-external-link-alt"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.loc.gov/research-centers/law-library-of-congress/researcher-resources/databases/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Kongresna pravna baza USA{" "}
                      <i className="fas fa-external-link-alt"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://hls.harvard.edu/library/research-services/legal-databases/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Pravna baza Univerziteta Harvard USA{" "}
                      <i className="fas fa-external-link-alt"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.lexisnexis.com/en-us/gateway.page"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Lexis Nexis Međunarodna Online Pravna biblioteka{" "}
                      <i className="fas fa-external-link-alt"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.gesetze-im-internet.de/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Njemačka baza važećih pravnih propisa{" "}
                      <i className="fas fa-external-link-alt"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.juris.de/jportal/nav/branchen/studium-und-hochschule/index.jsp"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Njemački pravni portal Juris{" "}
                      <i className="fas fa-external-link-alt"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://beck-online.beck.de/Home"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Beck Online njemačka pravna baza podataka{" "}
                      <i className="fas fa-external-link-alt"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.dalloz-actualite.fr/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Dalloz - Najveća francuska pravna baza podataka{" "}
                      <i className="fas fa-external-link-alt"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.legifrance.gouv.fr/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Francuska baza važećih pravnih propisa{" "}
                      <i className="fas fa-external-link-alt"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">{t("sidebar.follow")}</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Facebook"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Instagram"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">{t("sidebar.useful")}</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">{t("about.fpep")}</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">
                      {t("admission.Akreditacija")}
                    </Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">{t("upis.title")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">{t("admission.Skolarina")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">{t("saradnja.erasmus")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">{t("saradnja.projekti")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">{t("studenti.dom")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">{t("navbar.Gallery")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">{t("navbar.News")}</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">{t("sidebar.study")}</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>{t("programs.osnovne")}</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      {t("osnovne.rfb")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      {t("osnovne.menadzment")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      {t("osnovne.pravo")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>{t("programs.master")}</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      {t("master.poslovnaEkonomija")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      {t("master.ekonomijaJavnogSektora")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      {t("master.pravo")}
                      <br />
                    </Link>
                  </li>

                  <li>
                    <span className="post-date">
                      <strong>{t("programs.specijalisticke")}</strong> <br />
                    </span>
                    <Link to="/menadzment-javnog-sektora-specijalisticke">
                      {t("specijalisticke.mjs")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment-profitnog-sektora-specijalisticke">
                      {t("specijalisticke.mps")}
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default NaucnoistrazivackiRad;
